import { render, staticRenderFns } from "./AppLoginBox.vue?vue&type=template&id=0061b980&"
import script from "./AppLoginBox.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppLoginBox.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AppLoginBox.vue?vue&type=style&index=0&id=0061b980&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports